import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { TargetAudience } from './components/TargetAudience';
import { SolutionSection } from './components/SolutionSection';
import { ProductBreakdown } from './components/ProductBreakdown';
import { ValueStack } from './components/ValueStack';
import { OfferSection } from './components/OfferSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <TopBar data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <TargetAudience data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ProductBreakdown data-id="element-7" />
        <ValueStack data-id="element-8" />
        <OfferSection data-id="element-9" />
        <Testimonials data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>

      <footer className="bg-stone-950 text-stone-400 py-8 text-center text-sm" data-id="element-13">
        <div className="max-w-6xl mx-auto px-4" data-id="element-14">
          <p className="mb-2" data-id="element-15">
            © {new Date().getFullYear()} Chau Hígado Graso. Todos los derechos
            reservados.
          </p>
          <p className="text-xs text-stone-500 max-w-2xl mx-auto mt-4" data-id="element-16">
            Este producto no sustituye el consejo médico profesional,
            diagnóstico o tratamiento. Siempre busque el consejo de su médico u
            otro proveedor de salud calificado con cualquier pregunta que pueda
            tener sobre una condición médica.
          </p>
        </div>
      </footer>

      <SocialProofToast data-id="element-17" />
    </div>;
}